export default "__VITE_ASSET__DTBvL7Ht__"